// Components
import TextField from "@mui/material/TextField";
import { useTheme } from "@mui/material/styles";

// Styles
import {
  CustomTextFieldProps,
  getSurfaceTokens,
  getRequiredErrorColor,
} from "src/styles/mui/muiStylesHelper";

type TextInputFieldType = {
  id?: string;
  type?: string;
  autoFocus?: boolean;
  error?: boolean;
  helperText?: string;
  required?: boolean;
  disabled?: boolean;
  placeholder: string;
  value: string;
  maxLength?: number;
  onChange: (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => void;
};

const TextInputField = ({
  id,
  type,
  autoFocus = false,
  error = false,
  helperText = undefined,
  required = false,
  disabled = false,
  maxLength = 32,
  placeholder,
  value,
  onChange,
}: TextInputFieldType) => {
  const theme = useTheme();
  const { inputBorder } = getSurfaceTokens(theme);

  return (
    <TextField
      id={id ?? "text-input-field"}
      type={type}
      variant="outlined"
      color="warning"
      autoFocus={autoFocus}
      required={required}
      disabled={disabled}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      fullWidth
      sx={{
        "& .MuiFormHelperText-root": {
          marginTop: "4px",
          marginLeft: 0,
        },
        "& .MuiFormHelperText-root.Mui-error": {
          color: getRequiredErrorColor(theme),
          marginTop: "4px",
          marginLeft: 0,
        },
      }}
      InputProps={{
        sx: {
          ...CustomTextFieldProps(theme),
          ".MuiInputBase-input": { padding: "0px 16px" },
          ".MuiOutlinedInput-notchedOutline": {
            border: `1px solid ${inputBorder}`,
          },
        },
      }}
      error={error}
      helperText={helperText}
      inputProps={{
        maxLength,
        sx: {
          fontSize: "14px",
          "&::placeholder": {
            color: inputBorder,
            opacity: 1,
          },
        },
      }}
    />
  );
};

export default TextInputField;
